export default function isArrayOf<T>(isGuard: FieldGuard<T>, value: unknown): value is T[] {
  return Array.isArray(value) && value.every((item) => isGuard(item));
}

export function bindIsArrayOf<T>(typeGuard: FieldGuard<T>): (value: unknown) => value is T[] {
  return (value: unknown): value is T[] => isArrayOf(typeGuard, value);
}
